import i18next from 'i18next';

function isValidLocation(lat, lon) {
    return (
        lat != null && lon != null && isNaN(lat) == false && isNaN(lon) == false
    );
}

function formatLocation(lat, lon) {
    if (isValidLocation(lat, lon)) {
        return lat.toFixed(5) + ', ' + lon.toFixed(5);
    }

    return '';
}

export function formatEvents(rawEvents, lang, timeFormatter) {
    const elements = [];

    if (!rawEvents) {
        return elements;
    }
    for (const event of rawEvents) {
        const e = {};

        // Set a flag to let the user know the generated timestamp for this event is much older
        //  then the received timestamp, os we are giving our best guess
        const generated = new Date(event.generated_timestamp).valueOf();
        const received = new Date(event.received_timestamp).valueOf();

        // OLD timestamps are those older than a year
        const OLD_THRESHOLD = 1000 * 60 * 60 * 24 * 365;

        e.id = event.id;
        e.eventType = event.event_type;

        if (received - generated > OLD_THRESHOLD) {
            e.old = true;
            e.timestamp = timeFormatter.format(
                new Date(event.received_timestamp),
            );
            e.sort_time = received;
        } else {
            e.old = false;
            e.timestamp = timeFormatter.format(
                new Date(event.generated_timestamp),
            );
            e.sort_time = generated;
        }

        // Preserve raw timestamps for consumers that need stable time
        // comparisons independent of locale-formatted strings.
        e.generatedTimestampRaw = event.generated_timestamp;
        e.receivedTimestampRaw = event.received_timestamp;

        e.generatedTimestamp = timeFormatter.format(
            new Date(event.generated_timestamp),
        );
        e.alert = event.alarm;
        e.message = i18next.t(
            `eventNotifications.${event.event_type}`,
            event.msg_data,
        );
        e.latitude = event.latitude;
        e.longitude = event.longitude;

        if (event.latitude && event.longitude) {
            e.locationStr = formatLocation(event.latitude, event.longitude);
        }

        if (event.acknowledged_by) {
            e.acknowledgedBy = event.acknowledged_by.name;
        }

        elements.push(e);
    }

    return elements.sort((a, b) => b.sort_time - a.sort_time);
}
